import { SAMPLE_TYPES } from '@/consts/genetic-tests';

export const generateOrderCode = (): string => {
  const now = new Date(); // UTC
  // Format timestamp
  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, '0');
  const day = String(now.getUTCDate()).padStart(2, '0');
  const hours = String(now.getUTCHours()).padStart(2, '0');
  const minutes = String(now.getUTCMinutes()).padStart(2, '0');
  const seconds = String(now.getUTCSeconds()).padStart(2, '0');

  const timestamp = `${day}${month}${year}-${hours}${minutes}${seconds}`;

  // Add milliseconds for uniqueness
  const milliseconds = String(now.getUTCMilliseconds()).padStart(3, '0');
  return `${timestamp}-${milliseconds}`;
};

export const generateSampleTypeCode = (
  sampleTypeCode: string
): string | null => {
  const codeWithoutShort = generateOrderCode();

  const sampleType = SAMPLE_TYPES.find((st) => st.code === sampleTypeCode);

  if (!sampleType) {
    return null;
  }

  return `${codeWithoutShort}-${sampleType.shortCode}`;
};
